export const LegalController = {
    privacy(): void {},
    marketing(): void {},
    cookies(): void {},
};
